/**
 * @name safeDivide
 * @function
 *
 * @param {number} numerator - The numerator of the division.
 * @param {number} denominator - The denominator of the division.
 * @param {number} fallback - The value to return if the denominator is 0.
 * @returns {number} The result of the division, or the fallback value if the denominator is 0.
 */
export const safeDivide = (numerator, denominator, fallback = 0) => {
  if (isNaN(numerator) || isNaN(denominator) || denominator === 0) return fallback;

  return numerator / denominator;
};
